import { apiSlice } from '../api/apiSlice'
import { updateUserProfile } from './userSlice'

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getVerifyRequests: builder.query({
      query: () => ({
        url: '/users/verify-requests/',
        method: 'GET',
      }),
      providesTags: ['Verification-Requests'],
    }),
    editProfile: builder.mutation({
        query: profileObj => ({
            url: '/users/edit-profile/',
            method: 'PATCH',
            body: profileObj
        }),
        async onQueryStarted( profileObj, { dispatch, queryFulfilled }) {
            try {
              const { data: profile } = await queryFulfilled
              dispatch(updateUserProfile(profile))
            } catch (err) {
              console.error('Failed to add item', err)
            }
        }
    }),
    updateUserPassword: builder.mutation({
      query: (newInfo) => ({
        url: '/users/update-password/',
        method: 'PATCH',
        body: newInfo
      }),
    }),
    verifyRequest: builder.mutation({
      query: (profileInfo) => ({
        url: '/users/verify-requests/',
        method: 'POST',
        body: profileInfo
      }),
    }),
    handleVerifyRequest: builder.mutation({
      query: (decisionInfo) => ({
        url: '/users/handle-verify-request/',
        method: 'PATCH',
        body: decisionInfo
      }),
      invalidatesTags: ['Verification-Requests'],
    }),
  })
})

export const { 
  useGetVerifyRequestsQuery,
  useEditProfileMutation, 
  useUpdateUserPasswordMutation,
  useVerifyRequestMutation,
  useHandleVerifyRequestMutation,
 } = extendedApiSlice